import React, { useContext, useEffect, useState } from 'react'
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro'

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import CustomToolbar from '../../components/grid/CustomToolbar'
import SL_Button from '../../components/buttons/Button'
import CreateDentist from './CreateDentist'
import DetailDentist from './DetailDentist'
import { Button, Popconfirm } from 'antd'
import { UserAddOutlined, FileSearchOutlined } from '@ant-design/icons'
import DentistFilters from './DentistFilters'
import dentist_grid_columns from './grid_columns/dentist_grid_columns'
import { DateTime } from "luxon";
import { displayMessage } from '../../services/helper';


export default function ListDentist() {
    const { setShowLoading, windowHeight, mobile_mode, user } = useContext(GeneralContext)

    const [dentist, setDentist] = useState([])
    const [currentDentist, setCurrentDentist] = useState(null)
    const [isModalCreateDentistVisible, setIsModalCreateDentistVisible] = useState(false)
    const [isModalDetailDentistVisible, setIsModalDetailDentistVisible] = useState(false)

    const gridRef = useGridApiRef()
    const DataGridProHeight = windowHeight * 0.7

    useEffect(
        () => {
            loadDentistsData()
        },
        []
    )

    const loadDentistsData = async (currentFilters) => {
        try {

            setShowLoading(true)

            const payload = { dentist_id: currentFilters?.dentist_id, find_deleted: true }
            const rs = await api.dentist.list(payload)
            gridRef.current.setSelectionModel([])
            setDentist(rs.data)

        } finally {
            setShowLoading(false)
        }
    }

    const handleRowChange = (e) => {
        setCurrentDentist(e?.row)
    }

    const handleOnCloseModalCreateDentist = () => {
        setIsModalCreateDentistVisible(false)
    }
    const handleOnOpenModalCreateDentist = () => {
        setIsModalCreateDentistVisible(true)
    }

    const handleOnCloseModalDetailDentist = () => {
        setIsModalDetailDentistVisible(false)
    }
    const handleOnOpenModalDetailDentist = () => {
        setIsModalDetailDentistVisible(true)
    }

    const renderCustomToolBar = () => {
        return (
            <CustomToolbar />
        )
    }

    const handleOnClickResetPassword = dentist => {
        setShowLoading(true)
        api.auth.forceResetPassword(dentist).then(
            rs => {
                setShowLoading(false)
                alert(displayMessage('NEW_EMAIL_SENT_PASSWORD',[dentist?.email]), 'success')
                
            }
        )
    }

    const actionResetPassword = {
        field: 'action',
        headerName: displayMessage('RESET_PASSWORD'),
        width: 200,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div style={{ padding: 2 }}>
                    <Popconfirm zIndex={10001} placement="topLeft" title={displayMessage('COMFIRMATION_CHANGE_PASWORD')} onConfirm={() => handleOnClickResetPassword(params?.row)} okText={displayMessage('YES')} cancelText={displayMessage('NO')}>
                        <Button type="primary"> {displayMessage('RESET_PASSWORD')} </Button>
                    </Popconfirm>
                </div>

            )
        },
        disableColumnSelector: true
    }
    
    const actionDelete = {
      field: "action_exclude",
      headerName: displayMessage("DELETE_DENTIST"),
      width: 200,
      sortable: false,
      align: "center",
      renderCell: (params) => {
        return params.row.deletedAt ? (
          <Popconfirm
            zIndex={10001}
            placement="topLeft"
            title={displayMessage("COMFIRMATION_RECOVER_DENTIST")}
            disabled={params?.row?.deletedAt == null}
            onConfirm={() => handloOnClickRecoverDentist(params?.row)}
            okText={displayMessage("YES")}
            cancelText={displayMessage("NO")}
          >
            <Button type="primary" disabled={params?.row?.deletedAt == null}>
              {displayMessage("RECOVER_DENTIST")}
            </Button>
          </Popconfirm>
        ) : (
          <Popconfirm
            zIndex={10001}
            placement="topLeft"
            title={displayMessage("COMFIRMATION_EXCLUDE_DENTIST")}
            disabled={params?.row?.deletedAt != null}
            onConfirm={() => handloOnClickExcludeDentist(params?.row)}
            okText={displayMessage("YES")}
            cancelText={displayMessage("NO")}
          >
            <Button
              type="primary"
              danger={true}
              disabled={params?.row?.deletedAt != null}
            >
              {displayMessage("DELETE_DENTIST")}
            </Button>
          </Popconfirm>
        );
      },
      disableColumnSelector: true,
    };
    
    const deletedAt = {
      field: "deletedAt",
      headerName: displayMessage("DELETED"),
      type: "date",
      width: 200,
      sortable: true,
      align: "center",
      valueFormatter: (params) => {
        if (!params?.value) {
          return params?.value;
        }
        const data = DateTime.fromISO(params.value);
        return data.toFormat("dd/MM/yyyy");
      },
      disableColumnSelector: true,
    };

    
    const handloOnClickRecoverDentist = async (dentist) => {
      setShowLoading(true);
      try {
        const payload = {
          ...dentist,
          deletedAt: null,
          to_exclude: false,
          forced: true,
          user_id: user.id,
        };

        await api.dentist.recover(payload).then((res) => {
          alert(
            displayMessage("RECOVER_DENTIST_SUCEES", [
              dentist?.first_name,
              dentist?.last_name,
            ])
          );
        });
        await api.user.delete(dentist.id);
      } catch (error) {
        console.log(error);
      } finally {
        setShowLoading(false);
        loadDentistsData();
      }
    };
    
      const handloOnClickExcludeDentist = (dentist) => {
        setShowLoading(true);
    
        api.user.exclude(dentist.id).then((res) => {
          setShowLoading(false);
          alert(
            displayMessage("REMOVE_DENTIST_SUCEES", [
              dentist?.first_name,
              dentist?.last_name,
            ])
          );
          loadDentistsData();
        });
      };

    return (
        <>
            {
                isModalCreateDentistVisible
                &&
                <CreateDentist
                    isModalVisible={isModalCreateDentistVisible}
                    handleOnCloseModal={handleOnCloseModalCreateDentist}
                    refreshDentists={loadDentistsData}
                />
            }


            {
                isModalDetailDentistVisible
                &&
                <DetailDentist
                    isModalVisible={isModalDetailDentistVisible}
                    handleOnCloseModal={handleOnCloseModalDetailDentist}
                    dentist_id={currentDentist.id}
                    refreshDentists={loadDentistsData}
                />
            }

            <DentistFilters handleOnSearchDentists={loadDentistsData} />
            <div className='flex flex-col w-full'>

                <div style={{ height: DataGridProHeight, minHeight: 300 }} >

                    <div className={`flex flex-1 justify-between p-2 bg-appian-blue gap-1 ${mobile_mode ? `flex-col` : `flex-row`} `}>
                        <span className='self-center text-white flex-1 text-center font-medium'>{displayMessage('DENTIST_LIST')}</span>
                        <div className={`flex gap-1 ${mobile_mode ? `flex-col` : `flex-row`}`} >
                            <SL_Button
                                type='default'
                                className='items-center w-30 flex'
                                disabled={!currentDentist}
                                style={{ color: !currentDentist ? 'grey' : null, background: !currentDentist ? 'lightgrey' : null }}
                                onClick={handleOnOpenModalDetailDentist}
                                icon={<FileSearchOutlined />}
                            >
                                {displayMessage('DETAIL_DENTIST')}
                            </SL_Button>
                            <SL_Button
                                type='default'
                                className='items-center w-30 flex'
                                onClick={handleOnOpenModalCreateDentist}
                                icon={<UserAddOutlined />}
                            >
                                {displayMessage('CREATE_DENTIST')}
                            </SL_Button>
                        </div>

                    </div>


                    <DataGridPro
                        // rows={dentist ?? []}
                        rows={dentist}
                        apiRef={gridRef}
                        style={{ height: '100%' }}
                        columns={dentist_grid_columns.concat([
                            deletedAt, actionDelete,actionResetPassword
                        ])}
                        pagination
                        pageSize={100}
                        components={{
                            Toolbar: renderCustomToolBar,
                        }}
                        onRowClick={handleRowChange}
                        density="compact"
                        disableMultipleSelection
                    />
                </div>
            </div>
        </>
    )
}
